module.exports = __webpack_public_path__ + "media/images/icon-houses-e82a9ea33710961b24d623670438ed4a.png";